import { validateTripAddress } from '@/core/validators';

export default function validateFromAndToAddresses(obj, allowEqualAddresses) {
	let errors = {};

	errors.fromAddress = validateTripAddress(obj.fromAddress);
	errors.toAddress = validateTripAddress(obj.toAddress);

	if (!allowEqualAddresses && !errors.fromAddress && !errors.toAddress) {
		if (obj.fromAddress.id === obj.toAddress.id) {
			errors.fromAddress = 'cannotBeSameAsToAddress';
			errors.toAddress = 'cannotBeSameAsFromAddress';
		}
	}

	return errors;
}